
const SubHeading=({ children }) => {
    return (
        <h2 className="text-xl 2xl:text-3xl font-[500]">{children}</h2>
    )
}

export default SubHeading